// extracted by mini-css-extract-plugin
export default {"loadingState":"LoadingState_loadingState__radat","header":"LoadingState_header__4Yau0","avatar":"LoadingState_avatar__-StHW","info":"LoadingState_info__rLx-f"};